import { PageHeader } from '@ant-design/pro-layout'
import Editor from '@monaco-editor/react'
// eslint-disable-next-line sonarjs/deprecation
import { JsonSyntaxHighlighter, parseJsonIfValid, useBooleanState } from '@salescore/frontend-common'
import type { ModalFuncProps } from 'antd'
import { Alert, Button, Form, Space, Switch } from 'antd'
import { t } from 'i18next'
import type { ReactNode } from 'react'
import type { ZodType } from 'zod'

export interface DebugModalContentProperties {
  content: unknown
  schema?: ZodType
  onChange?: (x: unknown) => void
  onAfterFinish: () => void
}

export function buildViewDebugModalProperties(properties: DebugModalContentProperties): ModalFuncProps {
  return {
    icon: null,
    closable: true,
    maskClosable: true,
    width: '60%',
    cancelText: t(`閉じる`),
    okButtonProps: { style: { display: 'none' } },
    style: { top: '3%' },
    content: <DebugModalContent {...properties} />,
  }
}

// eslint-disable-next-line sonarjs/prefer-read-only-props
function DebugModalContent({ content, schema, onChange, onAfterFinish }: DebugModalContentProperties): ReactNode {
  // eslint-disable-next-line sonarjs/deprecation
  const isEditMode = useBooleanState()
  const isEditable = onChange !== undefined && schema !== undefined

  return (
    <>
      <PageHeader
        title={<div>{t(`スキーマ表示`)}</div>}
        extra={[
          <Space key="edit-mode" className="flex items-center align-middle">
            <span>{t(`編集モード`)}</span>
            <Switch
              disabled={!isEditable}
              onChange={() => {
                isEditMode.toggle()
              }}
              checked={isEditMode.isTrue}
            />
          </Space>,
        ]}
      />
      {isEditMode.isTrue && (
        <Alert
          className="mb-4"
          type="warning"
          showIcon
          message={t(`スキーマの直接編集は大変危険です。十分にスキーマの理解がある方だけが編集してください。`)}
        />
      )}
      {isEditable && isEditMode.isTrue ? (
        <EditableContent content={content} onChange={onChange} onAfterFinish={onAfterFinish} />
      ) : (
        <ReadonlyContent content={content} />
      )}
    </>
  )
}

// eslint-disable-next-line sonarjs/prefer-read-only-props
function ReadonlyContent({ content }: { content: unknown }) {
  return (
    <div>
      <JsonSyntaxHighlighter
        jsonString={
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          JSON.stringify(content) ?? ''
        }
      />
    </div>
  )
}

interface FormValue {
  content: string
}

function EditableContent({
  content,
  onChange,
  onAfterFinish,
}: Required<Pick<DebugModalContentProperties, 'onChange'>> & DebugModalContentProperties) {
  const onFinish = (value: FormValue) => {
    const parsed = parseJsonIfValid(value.content)
    // try {
    //   const validated = viewQueryFieldSchema.safeParse(parsed)
    //   if (validated.success) {
    //     onChange(parsed)
    //     void message.success(`更新しました`)
    //   } else {
    //     void message.error(`スキーマが一致しません。${validated.error.message}`)
    //   }
    // } catch(e) {
    // }
    // validationしたかったが、エラーも発生せずに処理が止まる不具合があったためvalidationしない
    onChange(parsed)
    onAfterFinish()
  }
  return (
    <Form
      onFinish={onFinish}
      layout="vertical"
      initialValues={{
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        content: JSON.stringify(content, null, 2) ?? '',
      }}
    >
      <Form.Item
        style={{
          height: 600,
          overflow: 'hidden',
        }}
        name="content"
        label={
          <div>
            {/* 検索条件(SQL){' '} */}
            {/* <Button
              size="small"
              onClick={() => {
                const sql = form.getFieldValue(`sql`) as string
                form.setFieldsValue({ sql: formatSqlWithMustache(sql) })
              }}
            >
              フォーマット
            </Button> */}
          </div>
        }
      >
        <Editor
          height={600}
          // width={500}
          theme="vs-dark"
          defaultLanguage="json"
          options={{
            minimap: {
              enabled: false,
            },
          }}
        />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          {t(`更新`)}
        </Button>
      </Form.Item>
    </Form>
  )
}
